import { ReactNode } from "react";
import { Layout } from "src/components/Layout";

interface Props {
  children: ReactNode;
  width: string;
}

export const TemplateFlowSuccessLayout: React.FC<Props> = ({ children, width }) => {
  return (
    <Layout
      width={width}
      paddingY={3}
      minHeight={`100vh`}
    >
      {children}
    </Layout>
  );
};